<template>
    <div class="HeaderNav">
        <v-tooltip
            color="black"
            left
            open-delay="1000"
        >
            <template #activator="{on, attrs}">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    to="/dashboard"
                >
                    <v-icon
                        small
                        color="white"
                    >
                        fas fa-home
                    </v-icon>
                </v-btn>
            </template>
            <span>Dashboard</span>
        </v-tooltip>

        <v-tooltip
            color="black"
            left
            open-delay="1000"
        >
            <template #activator="{on, attrs}">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    to="/page/support"
                >
                    <v-icon
                        small
                        color="white"
                    >
                        fas fa-question-circle
                    </v-icon>
                </v-btn>
            </template>
            <span>Support</span>
        </v-tooltip>

        <AccountSettings />

        <v-tooltip
            color="black"
            left
            open-delay="1000"
        >
            <template #activator="{on, attrs}">
                <v-btn
                    v-bind="attrs"
                    v-on="on"
                    icon
                    small
                    @click.once="signOut"
                >
                    <v-icon
                        small
                        color="white"
                    >
                        fas fa-lock
                    </v-icon>
                </v-btn>
            </template>
            <span>Sign Out</span>
        </v-tooltip>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import AccountSettings from '@/components/AccountSettings';

export default {
    name: 'PageHeader',
    components: { AccountSettings },
    computed: {
        ...mapState('auth', ['user'])
    },

    methods: {
        ...mapMutations({
            setSidebarMounted: 'sidebar/setSidebarMounted'
        }),

        ...mapActions({
            sendSignOut: 'auth/signOut',
            refreshSettings: 'settings/getAllSettings'
        }),

        signOut() {
            this.setSidebarMounted(false);
            this.sendSignOut();
        },

        showNavSlot(role, page) {
            if (role !== 'builder') {
                return true;
            }

            if (role === 'builder' && page === 'dashboard') {
                return true;
            }

            return false;
        }
    }
};
</script>
<style lang="scss">
.HeaderNav {
    margin-left: auto;

    a {
        margin-right: 8px !important;
    }
}
</style>
